/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import Question from './Question'
import QuestionTree from './QuestionTree'

export default class Flow {
  private json: any
  private _startingQuestion: QuestionTree
  private _editSelectionQuestions: Array<QuestionTree> = []
  private _currentQuestion?: QuestionTree
  private questions: Question[]
  public readonly backToSelectionText: string
  public readonly nextButtonText: string
  public readonly stepHeaderText: string
  public readonly estimatedOutOfPocketText: string

  constructor (data: any) {
    this.json = data
    this.questions = [
      Question.of(data.starting_question[0]),
      ...(data.additional_questions as Array<any>).map(q => Question.of(q))
    ]
    this._startingQuestion = QuestionTree.make(this.questions, data.starting_question[0].uid)
    this.backToSelectionText = this.json.back_to_selection_text
    this.nextButtonText = this.json.next_button_text
    this.stepHeaderText = this.json.step_header_text
    this.estimatedOutOfPocketText = this.json.estimated_out_of_pocket_text
  }

  get currentQuestion (): Question | undefined {
    return this._currentQuestion?.question
  }

  get hasPreviousQuestion (): boolean {
    return !!this._currentQuestion?.parent
  }

  get hasEditSelectionsQuestion (): boolean {
    return !!this._editSelectionQuestions.length
  }

  get progress () {
    if (!this._currentQuestion?.outOf) {
      return undefined
    }
    return {
      currentStep: this._currentQuestion?.index,
      totalSteps: this._currentQuestion?.outOf
    }
  }

  public getFirstQuestion (): Question {
    this._currentQuestion = this._startingQuestion
    return this._currentQuestion?.question
  }

  public getEditSelectionsQuestion (): Question | undefined {
    if (this._editSelectionQuestions.length) {
      [this._currentQuestion] = this._editSelectionQuestions.slice(-1)
      return this._currentQuestion.question
    }
  }

  public resetEditSelectionsQuestions () {
    this._editSelectionQuestions = []
  }

  public getNextQuestion (answerId: string): Question | undefined {
    if (!this._currentQuestion) {
      return undefined
    }

    const nextQuestion = this._currentQuestion?.children?.get(answerId)

    if (!nextQuestion) {
      return undefined
    }
    this._currentQuestion = nextQuestion

    if (nextQuestion.question.isEditSelectionsQuestion) {
      this._editSelectionQuestions.push(nextQuestion)
    }

    return nextQuestion.question
  }

  public getPreviousQuestion (): Question | undefined {
    const previousQuestion = this._currentQuestion?.parent

    if (!previousQuestion) {
      return undefined
    }

    if (this._currentQuestion?.question.isEditSelectionsQuestion) {
      this._editSelectionQuestions.pop()
    }

    this._currentQuestion = previousQuestion

    return previousQuestion?.question
  }

  static of (data: any): Flow {
    return new Flow(data)
  }
}
